// extracted by mini-css-extract-plugin
export default {"message":"views-EditorialPage-components-message__message--nNvNq"};